module.exports = __webpack_public_path__ + "7ffeda91bd0e6678cc2656097eeac253.png";